"use client";

import { AudioPlayerDownloadIsolation } from "@/components/audioPlayers/audioPlayerDownloadIsolation/AudioPlayerDownloadIsolation";
import { Heading4 } from "@/components/text/Heading4";
import { IsolationConstructedNoDates, UserNoDates } from "@/types/types";

export function IsolationHistory({
  isolationHistory,
  user,
}: {
  isolationHistory: IsolationConstructedNoDates[];
  user: UserNoDates;
}) {
  return (
    <>
      <Heading4 elementType="h2" className="mb-4 mt-6">
        History
      </Heading4>
      <div className="flex h-full flex-col gap-y-4 overflow-auto rounded-3xl p-2 pr-2 md:max-h-[700px]">
        {isolationHistory.map((isolationItem) => (
          <div key={isolationItem.id}>
            <AudioPlayerDownloadIsolation
              isolation={isolationItem}
              user={user}
            />
          </div>
        ))}
      </div>
    </>
  );
}
